import axios from "axios";

export const NoticeService = () => {

    const getNotices = async (page = 1, pageItemCount = 3) => {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}v1/notice/list?page=${page}&page_item_count=${pageItemCount}`);
        return response.data.data.notices;
    };

    const getNotice = async (id) => {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}v1/notice/get/${id}`);
        return response.data.data.notice;
    };

    return {
        getNotices,
        getNotice
    }
};